import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'

import { Button, Form, Select, SelectItem } from '@wfp/ui'

import '../assets/css/bootstrap.min.css'

import '../assets/css/app.css'
import '../assets/css/landing.css'

import DraftDocuments from './DraftDocuments'
import {
  narrativeHistoryFetchRequested,
  setNarrative,
  transitionCompleted,
  transitionRequested,
} from '../actions/narrative'
import { TRANSITION_SUCCEEDED } from '../constants'

class LandingPage extends Component {
  chooseCspText = 'Choose Country CSP'
  cspsLoadingText = 'Please wait, loading...'
  noCspsAuthorized = 'You are not authorized to work on any country'
  chooseYearText = 'Choose Year'

  state = {
    cspCountryKey: '',
    countryName: '',
    selectedYear: this.chooseYearText,
    data: {},
    visible: true,
    modalIsOpen: false,
    selectYears: '',
    draftDocuments: [],
    modalText: '',
    matchingNarrativeVersions: [],
  }

  selectOptions = () => {
    if (this.props.userInfo && this.props.userInfo.cspCountryKeys.length) {
      return this.props.userInfo.cspCountryKeys.map(key => {
        return (
          <SelectItem
            value={this.props.userInfo.cspsByCspCountryKey[key]['csp_country_key']}
            text={`${this.props.userInfo.cspsByCspCountryKey[key]['country_name']} - ${
              this.props.userInfo.cspsByCspCountryKey[key]['csp_country_key']
            } (${this.props.userInfo.cspsByCspCountryKey[key]['csp_period']})`}
            key={this.props.userInfo.cspsByCspCountryKey[key]['csp_country_key']}
          />
        )
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.transitionStatus === TRANSITION_SUCCEEDED) {
      // When we get notice that the "create" transition succeeded, redirect to the editors
      this.props.transitionCompleted()
      this.props.history.push({
        pathname: `/edit/${nextProps.narrative.id}`,
      })
    } else if (nextProps.userInfo && nextProps.userInfo.cspCountryKeys.length === 0) {
      // If UserInfo has loaded but has no CSPs show modal warning
      this.setState({
        modalIsOpen: true,
        modalText: this.noCspsAuthorized,
      })
    }
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  createNarrative = event => {
    event.target.disabled = true
    this.props.transitionRequested(
      {
        csp_country_key: this.state.cspCountryKey,
        year: this.state.selectedYear,
      },
      'initialize'
    )
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      modalText: '',
    })
  }

  onCountryChange = event => {
    const newCspCountryKey = event.target.value
    const csp = this.props.userInfo.cspsByCspCountryKey[newCspCountryKey]
    const selectableYears = csp.years.map(item => {
      return <SelectItem value={item} text={item} key={item} />
    })

    this.setState({
      cspCountryKey: newCspCountryKey,
      countryName: csp.country_name,
      cspPeriod: csp.csp_period,
      selectYears: selectableYears,
      selectedYear: this.chooseYearText,
    })
  }

  onYearChange = event => {
    const newYear = event.target.value
    this.props.narrativeHistoryFetchRequested(this.state.cspCountryKey, newYear)
    this.setState({ selectedYear: newYear })
  }

  countryAndYearSelected = () => {
    return (
      this.state.countryName !== '' &&
      this.state.countryName !== this.cspsLoadingText &&
      this.state.countryName !== this.chooseCspText &&
      this.state.selectedYear !== this.chooseYearText &&
      this.state.selectedYear !== ''
    )
  }

  render() {
    return (
      <div className='landing--ie-fix'>
        <div className='landing--wrapper'>
          <div className='landing--form'>
            <h2>Welcome to COMP NARRATIVES</h2>
            <p style={{ paddingTop: '7px' }}>Please select a CSP and year</p>
            <Form className='some-class'>
              &nbsp;
              <Select
                hideLabel
                className='some-class'
                id='select-1'
                onChange={this.onCountryChange}
                defaultValue={this.chooseCspText}>
                <SelectItem
                  disabled
                  hidden
                  value={this.chooseCspText}
                  text={
                    !this.props.userInfo
                      ? this.cspsLoadingText
                      : this.props.userInfo.cspCountryKeys.length
                      ? this.chooseCspText
                      : this.noCspsAuthorized
                  }
                />
                {this.selectOptions()}
              </Select>
              <Select
                hideLabel
                className='some-class'
                id='select-1'
                onChange={this.onYearChange}
                value={this.state.selectedYear}
                disabled={!this.state.selectYears}>
                <SelectItem disabled hidden value={this.chooseYearText} text={this.chooseYearText} />
                {this.state.selectYears}
              </Select>
              <Modal
                style={{ content: { right: '15%' } }}
                ariaHideApp={false}
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                contentLabel='Example Modal'>
                {this.state.modalText !== '' && (
                  <ul className='landing--form-menu'>
                    <li className='fullwidth'>
                      {/* <h2>You have 0 document to open.</h2> */}
                      <h2>{this.state.modalText}</h2>
                      <Button onClick={this.closeModal}>Close this window</Button>
                    </li>
                  </ul>
                )}
                {this.state.modalText === '' && this.props.narrativeHistory.length && (
                  <div>
                    <DraftDocuments
                      btnCloser={this.closeModal}
                      narratives={this.props.narrativeHistory}
                      history={this.props.history}
                    />
                    <Button onClick={this.closeModal} className='close-button'>
                      Close this window
                    </Button>
                  </div>
                )}
              </Modal>
              {!this.props.narrativeHistoryLoading &&
                this.props.narrativeHistory.length > 0 &&
                this.countryAndYearSelected() && (
                  <Button className='landing--form-btn' onClick={this.openModal}>
                    Open Existing
                  </Button>
                )}
              {!this.props.narrativeHistoryLoading &&
                this.props.narrativeHistory.length === 0 &&
                this.props.userInfo &&
                ['CO', 'HQ'].includes(this.props.userInfo.role) &&
                this.countryAndYearSelected() && (
                  <Button className='landing--form-btn-create' onClick={this.createNarrative}>
                    Create New
                  </Button>
                )}
              {!this.props.narrativeHistoryLoading &&
                this.props.narrativeHistory.length === 0 &&
                this.props.userInfo &&
                !['CO', 'HQ'].includes(this.props.userInfo.role) &&
                this.countryAndYearSelected() && (
                  <p style={{ paddingTop: '14px' }}>No narratives exist for this CSP and year.</p>
                )}
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  userInfo: state.appSettings.userInfo,
  narrative: state.narrative.narrative,
  transitionStatus: state.narrative.transitionStatus,
  narrativeHistory: state.narrative.narrativeHistory,
  narrativeHistoryLoading: state.narrative.narrativeHistoryLoading,
})

const mapDispatchToProps = {
  transitionRequested,
  setNarrative,
  transitionCompleted,
  narrativeHistoryFetchRequested,
}

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(LandingPage)

LandingPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage)

export default LandingPage
